import React from "react";
import Dashboard from "../../_metronic/_partials/dashboards/Dashboard";

export default function DashboardPage() {
  return <Dashboard />;
}
